import { Injectable } from '@angular/core';
import { CampaignFolderInterface } from 'app/models/campaign.model';
import { DataTransformAbstractGet } from 'app/modules/global/classes/data.transform.abstract.up';

@Injectable({
  providedIn: 'root',
})
export class CampaignFolderDataTransformGet extends DataTransformAbstractGet {
  transform(folder: CampaignFolderInterface): CampaignFolderInterface {
    return folder;
  }
}
